import { createContext, useContext } from 'react';

export const SelectorContext = createContext({
  // page: null,
  dispatch: () => {},
  capabilitySets: [],
  setCapabilitySet: (capabilitySet) => {},
  capabilitySet: null,
  selectedCapabilities: null,
  navigateToItem: () => {},
  activeItem: null,
  selectCapability: () => {},
  deselectCapability: () => {},
  selectCapabilities: () => {},
  deselectCapabilities: () => {},
});

export function useSelectorContext() {
  return useContext(SelectorContext);
}
